export default __webpack_public_path__ + "static/media/users.56155add.svg";